import request from '@/static/js/request'

export function activity_cate(param) {
    return request({
        url: 'activity_cate',
        method: 'post',
        data:param
    })
}


export function activity_list(param) {
    return request({
        url: 'activity_list',
        method: 'post',
        data:param
    })
}

export function activity_detail(param) {
    return request({
        url: 'activity_detail',
        method: 'post',
        data:param
    })
}